module.exports = __webpack_public_path__ + "static/media/normal-yd3.bd625693.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/lecture/normal-yd3.png
// module id = 2000
// module chunks = 6